import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router } from "@angular/router";
import { JwtHelper } from 'angular2-jwt';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ConstantService } from "./constant.service";
import { EspecificacionVehiculoEntity, CiudadEntity } from "./entities/especificacionesVehiculo"
import { BeneficiariosAsistenciaMedicaEntity } from "../../../views/masivos/datosGenerales/entities/beneficiarios_asistencia_medica_entity";
import { AsistenciaMedicaEntity } from "../../../views/masivos/datosGenerales/entities/asistencia_medica_entity";
import { ParametrosURL } from "./entities/parametrosURL_entity";
import { BuscaArchivos, CarpetasArchivo } from './entities/util_entity';
import { SiniestrosVamTit, SiniestroVam } from '../../../views/vam/titulares/entities/vam_titulares_entity';
import { SiniestroTracking, SiniestroTrackingVam } from '../../../views/siniestros/siniestros_entity';

declare var jQuery: any;

@Injectable()
export class UtilService {
  private url = "utils";
  patternSoloNumeros = /^[0-9.]/;
  patternSoloLetras = /^[A-Za-zñÑ ]/;
  patternSoloLetrasSinEspacio = /^[A-Za-zñÑ0-9]/;
  patternTodoNoEspacio = /^[a-zA-Z0-9\-_.:,;+!"#$%&/=?¡'\|°¬@¿¡]$/;
  constructor(public authHttp: AuthHttp) {
    let constantService = new ConstantService();
    this.url = constantService.API_ENDPOINT + this.url;
  }
  getMarcas(): Observable<EspecificacionVehiculoEntity[]> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getMarcas", options).map(this.extractData)
      .catch(this.handleError);
  }
  getModelos(marcaCod): Observable<EspecificacionVehiculoEntity[]> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getModelos/" + marcaCod, options).map(this.extractData)
      .catch(this.handleError);
  }
  getVersiones(modeloCod): Observable<EspecificacionVehiculoEntity[]> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getVersiones/" + modeloCod, options).map(this.extractData)
      .catch(this.handleError);
  }
  getExtras(): Observable<EspecificacionVehiculoEntity[]> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getExtras", options).map(this.extractData)
      .catch(this.handleError);
  }

  getCiudadMasivos(): Observable<CiudadEntity[]> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getCiudadesMasivos", options).map(this.extractData)
      .catch(this.handleError);
  }

  getDependientes(asistenciaMedicaEntity: AsistenciaMedicaEntity): Observable<BeneficiariosAsistenciaMedicaEntity[]> {
    let body = JSON.stringify(asistenciaMedicaEntity);
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/getDependientes", body, options).map(this.extractData)
      .catch(this.handleError);
  }

  soloNumeros(event: any) {
    let inputChar = String.fromCharCode(event.charCode);
    if (event.charCode != 0) {
      if (!this.patternSoloNumeros.test(inputChar.toString())) {
        event.preventDefault();
      }
    }
  }
  soloLetras(event: any) {
    let inputChar = String.fromCharCode(event.charCode);
    if (event.charCode != 0) {
      if (!this.patternSoloLetras.test(inputChar.toString())) {
        event.preventDefault();
      }
    }
  }

  soloLetrasSinEspacio(event: any) {
    let inputChar = String.fromCharCode(event.charCode);
    if (event.charCode != 0) {
      if (!this.patternSoloLetrasSinEspacio.test(inputChar.toString())) {
        event.preventDefault();
      }
    }
  }

  letrasNumerosSinEspacio(event: any) {
    let inputChar = String.fromCharCode(event.charCode);
    if (event.charCode != 0) {
      if (!this.patternTodoNoEspacio.test(inputChar.toString())) {
        event.preventDefault();
      }
    }
  }
  encriptaParametrosURL(parametros: ParametrosURL): Observable<string> {
    let body = JSON.stringify(parametros);
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/encriptaParametrosUrl", body, options).map(this.extractData)
      .catch(this.handleError);
  }

  getCarpetasAsegArchivosPorCliente(datos: BuscaArchivos): Observable<CarpetasArchivo> {
    let body = JSON.stringify(datos);
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/getCarpetasArchivosXCliente", body, options).map(this.extractData)
      .catch(this.handleError);
  }

  ConsultarSiniestroVam(siniestro: SiniestroVam): Observable<SiniestroTrackingVam> {
    let body = JSON.stringify(siniestro);
    let headers = new Headers({ 'Content-Type': 'applicatio n/json' });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/getTrackingAsistenciaVam", body, options).map(this.extractData)
      .catch(this.handleError);
  }

  getTieneONoDeducible(ciuCod: number, prodCod: number): Observable<boolean> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/tieneDeducible/" + ciuCod + "/" + prodCod, options).map(this.extractData)
      .catch(this.handleError);
  }

  getUriAsesorVirtual(ban: number): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/GetUriAsesorVirtual/" + ban, options).map(this.extractData)
      .catch(this.handleError);
  }

  TraerNombreMes(mes: number) {
    let nombreMes: string;

    switch (mes) {
      case 1:
        nombreMes = "Enero";
        break;
      case 2:
        nombreMes = "Febrero";
        break;
      case 3:
        nombreMes = "Marzo";
        break;
      case 4:
        nombreMes = "Abril";
        break;
      case 5:
        nombreMes = "Mayo";
        break;
      case 6:
        nombreMes = "Junio";
        break;
      case 7:
        nombreMes = "Julio";
        break;
      case 8:
        nombreMes = "Agosto";
        break;
      case 9:
        nombreMes = "Septiembre";
        break;
      case 10:
        nombreMes = "Octubre";
        break;
      case 11:
        nombreMes = "Noviembre";
        break;
      case 12:
        nombreMes = "Diciembre";
        break;
    }

    return nombreMes;
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }
  private handleError(error: any) {
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/util.service.ts